import axios from 'axios'
import { defaultContur, conturs, defaultStore, stores } from '../translations'
import { IS_TEST_ENV } from '../constants/environment'

const PROD_ENDPOINT_IDS = {
  [stores.ru]: 'GoldAppleWebsite',
  by: 'GoldApple.by',
  [stores.kz]: 'GoldApple.kz',
  [stores.qa]: 'Goldappleme.qatar',
  [stores.ae]: 'Goldappleme.qatar',
  [stores.sa]: 'Goldappleme.qatar',
}

/**
 * Возвращает endpointId для maestra/mindbox в зависимости от окружения и стора
 * @returns {string}
 */
function getEndpointId() {
  if (IS_TEST_ENV) {
    return defaultContur === conturs.me ? 'Goldappleme.qatar-test' : 'goldapple.ru-stage'
  }

  return (
    PROD_ENDPOINT_IDS[defaultStore] ||
    (defaultContur === conturs.me ? 'Goldappleme.qatar' : 'GoldAppleWebsite')
  )
}

/**
 * Фиксирует дату и время открытия игры в maestra.io/mindbox.ru
 * @param {string} customerId - Идентификатор клиента из sessionID в bridge-сообщении USER
 */
export function trackGameOpen(customerId) {
  if (!customerId) {
    return
  }

  const dateTimeUTC = new Date().toISOString().replace('T', ' ').slice(0, -1)
  const endpointId = getEndpointId()

  const urlMe = `https://api.maestra.io/v3/operations/async?endpointId=${endpointId}&operation=Tamagochi.SetLastGameOpenDateTime`
  const urlCIS = `https://api.mindbox.ru/v3/operations/async?endpointId=${endpointId}&operation=Tamagochi.SetLastGameOpenDateTime`
  const url = defaultContur !== conturs.me ? urlCIS : urlMe

  axios({
    method: 'POST',
    url,
    headers: {
      'Content-Type': 'application/json; charset=utf-8',
      Accept: 'application/json',
    },
    data: {
      customer: {
        customFields: {
          tamagochiLastGameOpenDateTimeUTC: dateTimeUTC,
        },
        ids: {
          backendID: customerId,
        },
      },
    },
  }).catch((e) => {
    console.log('GA TMG maestro error: ', e)
  })
}
